import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import ImageList from "@mui/material/ImageList";
import { StyledButton } from "../StyledComponents";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useSectionsData } from "../hooks/useSections";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import SectionListTile from "./SectionListTile";

const onSuccess = (query) => (data) => {
  switch (query) {
    case "sections-get":
      console.log("Sections fetched", data);
      break;
    default:
      console.log("fetch sections success");
  }
};

const onError = (query) => (error) => {
  switch (query) {
    case "sections-get":
      console.log("Sections error", error);
      break;
    default:
      console.log("some error on fetching sections");
  }
};

export default function SectionsList({ token }) {
  const navigate = useNavigate();
  const { locationId } = useParams();
  const [searchParams] = useSearchParams();

  const homeItemType = searchParams.get("homeItemType");

  const allowedTypes = ["place", "bigEvent"];

  const isValidHomeItemType = allowedTypes.includes(homeItemType);

  const sections = useSectionsData(
    onSuccess,
    onError,
    token.token,
    locationId,
    homeItemType === "bigEvent"
  );
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (!isValidHomeItemType) {
      navigate("/", { replace: true });
    }
  }, [isValidHomeItemType, navigate]);

  if (!isValidHomeItemType) {
    return null; // or a loading spinner during redirect
  }

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };

  const filteredSections = sections.data
    ? sections.data.filter((section) =>
        section.title.toLowerCase().includes(searchTerm)
      )
    : [];

  console.log(sections.data);

  return (
    <Stack
      spacing={5}
      alignItems="center"
      marginTop={4}
      marginBottom={8}
      paddingInline={7}
      minHeight="calc(100vh - 280px)"
    >
      <TextField
        label={"Search by Section Title"}
        variant="outlined"
        fullWidth
        value={searchTerm}
        onChange={handleSearchChange}
        sx={{
          borderRadius: "15px",
          "& .MuiOutlinedInput-root": {
            borderRadius: "15px",
          },
        }}
      />
      <>
        <Stack
          spacing={5}
          width="100%"
          alignItems="center"
          direction="row"
          justifyContent="space-between"
        >
          <Typography
            variant="h1"
            align="center"
            color="#1EABF1"
            fontSize={38}
            fontFamily="Trueno Light"
          >
            Sections on Join
          </Typography>
          <Link
            to={`/addSection/${locationId}?homeItemType=${homeItemType}`}
            style={{ textDecoration: "none" }}
          >
            <StyledButton
              variant="contained"
              size="large"
              myColor="#1EABF1"
              hoverColor="#187DDA"
            >
              Add new Section
            </StyledButton>
          </Link>
        </Stack>
        {sections.isLoading ? (
          <CircularProgress sx={{ color: "#1EABF1" }} />
        ) : sections.isError ? (
          <h2>{sections.error.message}</h2>
        ) : (
          <ImageList
            cols={4}
            gap={40}
            rowHeight={250}
            style={{ display: "flex", flexWrap: "wrap" }}
          >
            {filteredSections.map((section) => (
              <SectionListTile
                key={section.sectionId}
                token={token}
                sectionId={section.sectionId}
                title={section.title}
                subtitle={section.subtitle}
                text={section.text}
                imageFileName={section.photos[0]}
                homeItemType
              />
            ))}
          </ImageList>
        )}
      </>
    </Stack>
  );
}
